<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card>
                    <v-card-title>
                        <span
                            class="headline">
                            {{ $vuetify.lang.t('$vuetify.errorModal.somethingWrong')}}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                {{ msg }}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="submitBtn()">
                            {{ $vuetify.lang.t('$vuetify.errorModal.close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            dialog: false
        }
    },
    props: {
        msg: {
            type: String,
            default: ''
        }
    },
    methods: {
        submitBtn () {
            this.$emit('ok-submit')
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
